const FAMILY_CROSS_ACTION_TYPE = {
  GET_FAMILIES_CROSS: 'GET_FAMILIES_CROSS',
  GET_FAMILY_CROSS: 'GET_FAMILY_CROSS',
  CREATE_FAMILY_CROSS: 'CREATE_FAMILY_CROSS',
  UPDATE_FAMILY_CROSS: 'UPDATE_FAMILY_CROSS',
  DELETE_FAMILY_CROSS: 'DELETE_FAMILY_CROSS',
  CREATE_FAMILY_CROSS_NOTE: 'CREATE_FAMILY_CROSS_NOTE',
  UPDATE_FAMILY_CROSS_NOTE: 'UPDATE_FAMILY_CROSS_NOTE',
  DELETE_FAMILY_CROSS_NOTE: 'DELETE_FAMILY_CROSS_NOTE'
}
export default FAMILY_CROSS_ACTION_TYPE
